import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Format godziny HH:MM (24h) - lustrzane odbicie @Matches z backendu
 * (dto/pricing-rules.dto.ts, checkInTime / checkOutTime). Serwer jest
 * ostatecznym walidatorem, tu chodzi wyłącznie o UX.
 */
export const TIME_HH_MM_PATTERN = /^([01]\d|2[0-3]):[0-5]\d$/;

/**
 * Sprawdza, czy kontrolka trzyma godzinę w formacie HH:MM.
 * Pustą wartość obsługuje osobno `required`.
 */
export function timeHhMmValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = (control.value ?? '').toString().trim();
    if (!value) {
      return null;
    }
    return TIME_HH_MM_PATTERN.test(value) ? null : { timeFormat: true };
  };
}
